import commands from './command-nodes';
import dataframes from './dataframe-nodes';
import { formatNodes, taskNodes } from './side-bar-config';

export const NodeDisplayGroup = {
  dataframes,
  commands,
  connectors: [],
  formats: formatNodes,
  tasks: taskNodes,
};
